import { render, staticRenderFns } from "./TeacherFilter.vue?vue&type=template&id=118cabb6&scoped=true"
import script from "./TeacherFilter.vue?vue&type=script&lang=js"
export * from "./TeacherFilter.vue?vue&type=script&lang=js"
import style0 from "./TeacherFilter.vue?vue&type=style&index=0&id=118cabb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cabb6",
  null
  
)

export default component.exports